/**
 * JudgePage - Main routing component for the judge/TISSI interface.
 *
 * Routes:
 * - /judge - Landing page with game queue
 * - /judge/new - Start new game manually
 * - /judge/game/:gameId - Game scoring interface
 * - /judge/faq - FAQ page
 */

import { Routes, Route } from 'react-router-dom';

import { FaqPage } from '@/features/judge/FaqPage';
import { GameScoringPage } from '@/features/judge/GameScoringPage';
import { LandingPage } from '@/features/judge/LandingPage';
import { NewGamePage } from '@/features/judge/NewGamePage';

export function JudgePage() {
  return (
    <Routes>
      <Route index element={<LandingPage />} />
      <Route path="new" element={<NewGamePage />} />
      <Route path="game/:gameId" element={<GameScoringPage />} />
      <Route path="faq" element={<FaqPage />} />
    </Routes>
  );
}
